<template>
  <div
    id="mapWrap"
    class="map-wrapper"
  >
    <div class="zoom-buttons">
      <button id="zoomInButton">
        <feather-icon
          icon="PlusIcon"
          size="16"
          color="#424148"
        />
      </button>
      <button id="zoomOutButton">
        <feather-icon
          icon="MinusIcon"
          size="16"
          color="#424148"
        />
      </button>
      <button id="resetButton">
        <feather-icon
          icon="CrosshairIcon"
          size="16"
          color="#424148"
          style="position: relative;top: -1px;"
        />
      </button>
    </div>
    <b-alert
      :show="hasError"
      variant="danger"
    >
      <div class="alert-body">
        Ошибка загрузки карты
      </div>
    </b-alert>

    <inline-svg
      v-show="!loadingSeats"
      id="map"
      class="map-svg"
      :src="mapSrc()"
      @loaded="svgLoaded($event)"
      @error="svgLoadError($event)"
    />

    <div
      v-if="loadingSeats && !hasError"
      class="d-flex align-items-center justify-content-center load-map"
    >
      <div class="spinner-border text-primary mr-2" />
      Загрузка карты...
    </div>
    <div
      v-show="TShow"
      class="map-tooltip"
      :class="getTooltipVariant"
      :style="{top: TTop+'px', left: TLeft+'px'}"
    >
      <span class="triangle" />
      <div
        class="map-tooltip__content"
        v-html="TText"
      />
    </div>

    <b-list-group
      v-show="MContextShow"
      class="context-menu"
      :style="{top: MTop+'px', left: MLeft+'px'}"
    >
      <b-list-group-item
        v-show="MContextShowItem"
        href="#"
        data-select="row"
        @click="selectSeats"
      >
        Выбрать ряд
      </b-list-group-item>
      <b-list-group-item
        v-show="MContextShowItem"
        href="#"
        data-select="sector"
        @click="selectSeats"
      >
        Выбрать сектор
      </b-list-group-item>
      <b-list-group-item
        v-show="MContextShowItem"
        href="#"
        data-select="price_all"
        @click="selectSeats"
      >
        Выбрать по цене
      </b-list-group-item>
      <b-list-group-item
        v-show="MContextShowItem"
        href="#"
        data-select="price"
        @click="selectSeats"
      >
        Выбрать ряд по цене
      </b-list-group-item>
      <b-list-group-item
        v-show="seatMarksContextMenu"
        href="#"
        data-select="seat-marks"
        @click="editSeatMarks"
      >
        Свойства места
      </b-list-group-item>
      <b-list-group-item
        v-show="history"
        href="#"
        data-select="history"
        @click="goHistory"
      >
        История места
      </b-list-group-item>
      <b-list-group-item
        v-show="MContextShowOrderItem"
        href="#"
        data-select="order"
        @click="goOrder"
      >
        Заказ
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { BAlert, BListGroup, BListGroupItem } from 'bootstrap-vue'
import InlineSvg from 'vue-inline-svg'
import panzoom from 'panzoom'
import store from '@/store'
import router from '@/router'
import { formatSeatMarksTooltip } from '@/utils/seatMarks'

export default {
  name: 'Hall',
  components: {
    InlineSvg,
    BAlert,
    BListGroup,
    BListGroupItem,
  },
  props: {
    hallId: {
      type: Number,
      required: true,
    },
    tooltip: {
      type: Boolean,
      default: true,
    },
    tooltipTemplate: {
      type: String,
      default: 'Зона #S# ряд #R# место #M#',
    },
    history: {
      type: Boolean,
      default: true,
    },
    orderItem: {
      type: Boolean,
      default: true,
    },
    cursorPointer: {
      type: Boolean,
      default: false,
    },
    getDbSeats: {
      type: Boolean,
      default: false,
    },
    filterSeats: {
      type: Boolean,
      default: false,
    },
    filterShow: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: {
      type: Array,
      default() {
        return []
      },
    },
    tooltipVariant: {
      type: Number,
      default: 0,
    },
    defaultDisabled: {
      type: Boolean,
      default: false,
    },
    isWidget: {
      type: Boolean,
      default: false,
    },
    enablePanZoom: {
      type: Boolean,
      default: false,
    },
    LBackLight: {
      type: Array,
      default() {
        return []
      },
    },
    LStatusSeats: {
      type: Array,
      default() {
        return []
      },
    },
    LQuotaSeats: {
      type: Array,
      default() {
        return []
      },
    },
    isVisiblePlaceNumber: {
      type: Boolean,
      default: false,
    },
    seatMarksContextMenu: {
      type: Boolean,
      default: false,
    },
    seatMarksBySeat: {
      type: Object,
      default() {
        return {}
      },
    },
    seatMarksShowMetadata: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      srcPath: '/maps/HALL_ID',
      hasError: false,
      seatObjects: [],
      seatActive: [],
      TShow: false,
      TTop: 0,
      TLeft: 0,
      TText: '',
      loadingSeats: true,
      zoomLevel: 1,
      MContextShow: false,
      MContextShowItem: true,
      MContextShowOrderItem: true,
      MTop: 0,
      MLeft: 0,
      eventBC: new BroadcastChannel('async-event'),
    }
  },
  emits: ['seatClick', 'mapLoaded', 'goHistoryEventSeat', 'goOrderEventSeat', 'editSeatMarks'],
  computed: {
    getTooltipVariant() {
      if (this.tooltipVariant > 0) {
        return `tooltip-variant-${this.tooltipVariant}`
      }
    },
  },
  watch: {
    disabled(disabledList, oldDisabledList) {
      const mapElement = document.getElementById('map')
      disabledList.forEach(item => {
        const seatElement = document.getElementById(item.id) || (mapElement ? mapElement.querySelector(`[seat="${item.id}"]`) : null)
        if (seatElement) {
          seatElement.classList.add('disabled')
          if (item.color) {
            seatElement.style.stroke = item.color
          }
          if (item.fillColor) {
            seatElement.style.fill = item.fillColor
          }
        }
      })

      const removedFromDisable = oldDisabledList.filter(item1 => !disabledList.some(item2 => item2.id === item1.id))
      if (removedFromDisable.length > 0) {
        removedFromDisable.forEach(item => {
          const seatElement = mapElement ? mapElement.querySelector(`[seat="${item.id}"]`) : null
          if (seatElement) {
            seatElement.classList.remove('disabled')
            if (item.color) {
              seatElement.style.stroke = item.color
            }
            if (item.restoreColor) {
              seatElement.style.fill = item.restoreColor
              seatElement.style.stroke = item.restoreColor
            }
          }
        })
      }
    },
    LBackLight(lightList) {
      let arr
      lightList.forEach(data => {
        arr = data
      })
      if (!arr) {
        this.resetSeatOpacity()
        return
      }
      this.seatClickColor(arr[0], arr[1])
    },
    LStatusSeats(statusList) {
      let arr = []
      statusList.forEach(data => {
        arr = data
      })
      if (!arr.length) {
        this.seatClickStatus('', false, [])
        return
      }
      this.seatClickStatus(arr[0], arr[1], arr[2])
    },
    LQuotaSeats(quotaSeatsList) {
      if (!quotaSeatsList || quotaSeatsList.length === 0) {
        return
      }

      let arr
      quotaSeatsList.forEach(data => {
        arr = data
      })
      if (!arr) {
        this.seatClickQuota(false, [])
        return
      }
      this.seatClickQuota(arr[0], arr[1])
    },
  },
  methods: {
    mapSrc() {
      return this.srcPath.replace('HALL_ID', this.hallId)
    },
    svgLoaded(e) {
      this.hasError = false
      const self = this
      const mapElement = document.getElementById('map')
      const allSeats = mapElement.querySelectorAll('[ref]')
      this.seatObjects = allSeats

      // Оптимизированная итерация: объединяем все операции в один цикл
      const seatElements = []
      allSeats.forEach(el => {
        const id = el.getAttribute('ref')
        const seatElement = document.getElementById(id)
        if (!seatElement) return

        seatElements.push(seatElement)

        // Добавляем классы
        seatElement.classList.add('map-seat')
        if (this.cursorPointer) {
          seatElement.classList.add('cursor-pointer')
        }
        if (this.defaultDisabled) {
          seatElement.classList.add('disabled')
        }

        if (this.isVisiblePlaceNumber) {
          this.setPlaceText(el)
        }

        // Фильтрация мест (если включена)
        if (this.filterSeats && !this.filterShow.includes(id)) {
          seatElement.classList.add('filter-hide')
        }
      })

      // Делегирование событий вместо индивидуальных обработчиков
      if (mapElement) {

        mapElement.addEventListener('mouseover', (event) => {
          const target = event.target

          if (target.classList.contains('map-seat')) {
            self.seatMouseOver({ target })
            if(!this.isWidget && this.eventBC) {
              const seatId = target.getAttribute('seat') || target.id
              this.eventBC.postMessage({activeSeatId: seatId})
            }
          } else {
            if(!this.isWidget && this.eventBC) this.eventBC.postMessage({ activeSeatId: null })
          }
        }, true)

        mapElement.addEventListener('mouseout', (event) => {
          const target = event.target
          if (target.classList.contains('map-seat')) self.seatMouseOut({ target })
          if(!this.isWidget && this.eventBC) this.eventBC.postMessage({ cursor: null })
        }, true)

        mapElement.addEventListener('click', (event) => {
          const target = event.target
          if (target.classList.contains('map-seat')) {
            if (target.classList.contains('disabled')) {
              return false
            }
            self.seatClick({ target })
          }
        }, true)
      }

      const contentBody = document.querySelector('.content-body')
      if (contentBody) {
        contentBody.addEventListener('contextmenu', (el) => {
          const id2 = el.target.getAttribute('ref')
          if (id2) {
            if (el.target.classList.contains('disabled') && this.orderItem) {
              this.MContextShowItem = false
              this.MContextShowOrderItem = true
            } else {
              this.MContextShowItem = true
              this.MContextShowOrderItem = false
            }

            self.menuContextClick(el)
            el.preventDefault()
            return false
          }
          this.MContextShow = false
        })
      }

      document.addEventListener('click', (el) => {
        const parentTarget = el.target.closest('.context-menu')
        if (!parentTarget) {
          this.MContextShow = false
        }
      })

      if (this.getDbSeats) {
        this.loadingSeats = true
        this.getHallRealSeats()
      } else {
        this.loadingSeats = false
        this.$emit('mapLoaded')
      }

      if (this.enablePanZoom) {
        // Используем requestAnimationFrame вместо setTimeout для более быстрой инициализации
        const initPanZoom = () => {
          const element = document.getElementById('map')
          if (!element || !element.getBoundingClientRect().width) {
            // Если SVG еще не готов, ждем следующий кадр
            requestAnimationFrame(initPanZoom)
            return
          }

          const zoomInButton = document.getElementById('zoomInButton')
          const zoomOutButton = document.getElementById('zoomOutButton')
          const resetButton = document.getElementById('resetButton')
          const mapWrap = document.getElementById('mapWrap')
          const coords = mapWrap.getBoundingClientRect()
          const svgCoords = element.getBoundingClientRect()
          const cx = coords.width / 2
          const cy = coords.height / 2
          const centerCenter = { x: 0.5, y: 0.5 }

          const mypanzoom = panzoom(element, {
            smoothScroll: false,
            zoomDoubleClickSpeed: 1,
            maxZoom: 8,
            minZoom: 0.2,
            transformOrigin: centerCenter,
            bounds: false,
            boundsPadding: 0.2,
            boundsDisabledForZoom: true,
            onTouch(e) {
              if (e.touches.length > 1) {
                return true
              }
              return false
            },
            filterKey: () => true,
          })

          mypanzoom.on('transform', e => {
            const { scale } = e.getTransform()
            const textNS = element.querySelectorAll('.textNS')
            if (scale > 3) {
              textNS.forEach(item => {
                item.style.display = 'block'
              })
            } else {
              textNS.forEach(item => {
                item.style.display = 'none'
              })
            }
          })

          zoomInButton.addEventListener('click', zoomClick)
          zoomOutButton.addEventListener('click', zoomClick)
          resetButton.addEventListener('click', resetClick)

          function zoomClick(e) {
            e.preventDefault()
            const isZoomIn = e.currentTarget.id === 'zoomInButton'
            const zoomBy = isZoomIn ? 1.2 : 0.8
            mypanzoom.zoomTo(cx, cy, zoomBy)
          }

          function initZoomAndPosition() {
            if (svgCoords.height > coords.height) {
              const initZoom = coords.height / svgCoords.height
              mypanzoom.zoomAbs(0, 0, initZoom)
              mypanzoom.moveTo(cx - ((svgCoords.width * initZoom) / 2), 0)
            } else {
              const initZoom = coords.width / svgCoords.width
              mypanzoom.zoomAbs(0, 0, initZoom)
              mypanzoom.moveTo(0, cy - ((svgCoords.height * initZoom) / 2), 0)
            }
          }

          function resetClick(e) {
            e.preventDefault()
            initZoomAndPosition()
          }

          // init zoom and position
          element.style.opacity = 1
          initZoomAndPosition()
        }

        requestAnimationFrame(initPanZoom)
      }
    },

    menuContextClick(el) {
      // menuContext
      this.MContextShow = true
      const leftoffset = 6
      const topoffset = 20
      const mapWrapper = document.querySelector('.map-wrapper')
      const wrapperLeft = mapWrapper ? mapWrapper.getBoundingClientRect().left : 0
      const wrapperTop = mapWrapper ? mapWrapper.getBoundingClientRect().top : 0

      this.MTop = (el.target.getBoundingClientRect().top - wrapperTop) + topoffset
      this.MLeft = (el.target.getBoundingClientRect().left - wrapperLeft) + leftoffset
      this.seatActive = el
    },
    goHistory() {
      const dbid = this.seatActive.target.getAttribute('seat')
      this.$emit('goHistoryEventSeat', dbid)
    },
    goOrder() {
      const dbid = this.seatActive.target.getAttribute('seat')
      this.$emit('goOrderEventSeat', dbid)
    },
    editSeatMarks() {
      const seatId = this.seatActive.target.getAttribute('seat')
      this.MContextShow = false
      this.$emit('editSeatMarks', seatId)
    },
    selectSeats(el) {
      const dataVariant = el.target.getAttribute('data-select')
      const row = this.seatActive.target.getAttribute('xr')
      const sector = this.seatActive.target.getAttribute('ls') || this.seatActive.target.getAttribute('rs')
      const colorPrice = this.seatActive.target.getAttribute('color')
      const mapElement = document.getElementById('map')
      const allSeats = mapElement ? mapElement.querySelectorAll('[ref]') : []
      this.seatObjects = allSeats

      if (dataVariant == 'row') {
        allSeats.forEach(seatEl => {
          if (!seatEl.classList.contains('disabled')) {
            const s = seatEl.getAttribute('ls') || seatEl.getAttribute('rs')
            const r = seatEl.getAttribute('xr')
            if (row == r && sector == s) {
              const refId = seatEl.getAttribute('ref')
              const actualSeatElement = document.getElementById(refId)
              if (actualSeatElement && !actualSeatElement.classList.contains('disabled')) {
                actualSeatElement.dispatchEvent(new MouseEvent('click', { bubbles: true }))
              }
              this.MContextShow = false
            }
          }
        })
      } else if (dataVariant == 'sector') {
        allSeats.forEach(seatEl => {
          if (!seatEl.classList.contains('disabled')) {
            const s = seatEl.getAttribute('ls') || seatEl.getAttribute('rs')
            if (sector == s) {
              const refId = seatEl.getAttribute('ref')
              const actualSeatElement = document.getElementById(refId)
              if (actualSeatElement && !actualSeatElement.classList.contains('disabled')) {
                actualSeatElement.dispatchEvent(new MouseEvent('click', { bubbles: true }))
              }
              this.MContextShow = false
            }
          }
        })
      } else if (dataVariant == 'price') {
        allSeats.forEach(seatEl => {
          if (!seatEl.classList.contains('disabled')) {
            const s = seatEl.getAttribute('ls') || seatEl.getAttribute('rs')
            const r = seatEl.getAttribute('xr')
            const color = seatEl.getAttribute('color')
            if (row === r && sector === s && colorPrice === color) {
              const refId = seatEl.getAttribute('ref')
              const actualSeatElement = document.getElementById(refId)
              if (actualSeatElement && !actualSeatElement.classList.contains('disabled')) {
                actualSeatElement.dispatchEvent(new MouseEvent('click', { bubbles: true }))
              }
              this.MContextShow = false
            }
          }
        })
      } else if (dataVariant == 'price_all') {
        allSeats.forEach(seatEl => {
          if (!seatEl.classList.contains('disabled')) {
            const color = seatEl.getAttribute('color')
            if (colorPrice === color) {
              const refId = seatEl.getAttribute('ref')
              const actualSeatElement = document.getElementById(refId)
              if (actualSeatElement && !actualSeatElement.classList.contains('disabled')) {
                actualSeatElement.dispatchEvent(new MouseEvent('click', { bubbles: true }))
              }
              this.MContextShow = false
            }
          }
        })
      } else if (dataVariant == 'history') {
        this.MContextShow = false
      } else if (dataVariant == 'order') {
        this.MContextShow = false
      }
    },
    svgLoadError(e) {
      this.hasError = true
    },
    seatMouseOver(el) {
      // Tooltip
      if (this.tooltip) {
        this.TShow = true

        const seatRect = el.target.getBoundingClientRect()
        const containerRect = el.target.closest('.map-wrapper').getBoundingClientRect()

        this.TTop = seatRect.top - containerRect.top
        this.TLeft = seatRect.left - containerRect.left + seatRect.width / 2
        this.TText = this.getTooltipText(el.target)
      }
    },
    seatMouseOut(el) {
      // Tooltip
      if (this.tooltip) {
        this.TShow = false
      }
    },
    seatClick(el) {
      const id = el.target.getAttribute('ref')
      const dbid = el.target.getAttribute('seat')
      this.$emit('seatClick', id, dbid)
    },
    seatHover(el, out) {
      const color = el.target.getAttribute('color')
      const mapElement = document.getElementById('map')
      const allSeats = mapElement ? mapElement.querySelectorAll('[ref]') : []
      this.seatObjects = allSeats
      allSeats.forEach(seatEl => {
        if (!seatEl.classList.contains('disabled')) {
          if (out) {
            const colors = seatEl.getAttribute('color')
            seatEl.style.opacity = (color === colors) ? '1' : '0.4'
          } else {
            seatEl.style.opacity = '1'
          }
        }
      })
    },
    seatClickColor(zone, isActive) {
      const mapElement = document.getElementById('map')
      const allSeats = mapElement ? mapElement.querySelectorAll('[ref]') : []
      allSeats.forEach(seatEl => {
        if (!seatEl.classList.contains('disabled')) {
          const seat = this.$parent.getEventSeatById(seatEl.getAttribute('seat'))
          if (isActive) {
            seatEl.style.opacity = (zone === seat.price_zone) ? '1' : '0.4'
          } else {
            seatEl.style.opacity = '1'
          }
        }
      })
    },
    resetSeatOpacity() {
      const mapElement = document.getElementById('map')
      const allSeats = mapElement ? mapElement.querySelectorAll('[ref]') : []
      allSeats.forEach(seatEl => {
        seatEl.style.opacity = '1'
      })
    },
    seatClickQuota(isActive, arrSeatId) {
      const mapElement = document.getElementById('map')
      const allSeats = mapElement ? mapElement.querySelectorAll('[ref]') : []
      const visibleSeatIds = new Set(arrSeatId.map(seatId => String(seatId)))
      allSeats.forEach(seatEl => {
        if (!seatEl.classList.contains('disabled')) {
          seatEl.style.opacity = isActive && !visibleSeatIds.has(seatEl.getAttribute('seat')) ? '0.4' : '1'
        }
      })
    },
    seatClickStatus(status, isActive, arrSeatId) {
      const mapElement = document.getElementById('map')
      if (!mapElement) return

      if (isActive && arrSeatId.length > 0) {
        const circles = mapElement.querySelectorAll('circle')
        circles.forEach(circle => circle.classList.remove('circle-outline'))
        arrSeatId.forEach(seatId => {
          const seat = mapElement.querySelector(`[seat="${seatId}"]`)
          if (seat) seat.classList.add('circle-outline')
        })
      } else if (status == '' && arrSeatId.length > 0) {
        const circles = mapElement.querySelectorAll('circle')
        circles.forEach(circle => circle.classList.remove('circle-outline'))
        arrSeatId[0].forEach(seatId => {
          const seat = mapElement.querySelector(`[seat="${seatId.seat_id}"]`)
          if (seat) seat.classList.add('circle-outline')
        })
      } else {
        const circles = mapElement.querySelectorAll('circle')
        circles.forEach(circle => circle.classList.remove('circle-outline'))
      }
    },
    getTooltipText(el) {
      const s = el.getAttribute('ls') || el.getAttribute('rs')
      const r = el.getAttribute('xr')
      const m = el.getAttribute('xm')
      const test = this.tooltipTemplate.replace(/#S#|#R#|#M#|#C#|#Z#|#P#|#Q#/gi, matched => {
        const map = {
          '#S#': s,
          '#R#': r,
          '#M#': m,
        }
        if (!map.hasOwnProperty(matched)) {
          return this.$parent.getTooltipAttribute(matched, el.getAttribute('id'), el.getAttribute('seat'))
        }
        return map[matched]
      })

      const tempEl = document.createElement('div')
      tempEl.innerHTML = test
      const htmlElements = tempEl.getElementsByTagName('*')
      const arrHtmlElements = Array.from(htmlElements)
      arrHtmlElements.forEach(e => {
        if (e.dataset.vIf) {
          const checkVar = this.$parent.getTooltipAttribute(`#${e.dataset.vIf}#`, el.getAttribute('id'), el.getAttribute('seat'))
          if (checkVar === null || typeof checkVar === 'undefined' || checkVar.length === 0) {
            e.style.display = 'none'
          }
        }
      })
      const seatMarks = formatSeatMarksTooltip(this.seatMarksBySeat[el.getAttribute('seat')], {
        showMetadata: this.seatMarksShowMetadata,
      })
      const result = `${tempEl.innerHTML}${seatMarks}`
      tempEl.remove()
      return result
    },
    getHallRealSeats() {
      const dispatchPrefix = (this.isWidget) ? 'widget' : 'api'
      store.dispatch(`${dispatchPrefix}/fetchSeats`, { hall_id: this.hallId })
        .then(response => {
          const seats = response.data.data || []
          seats.forEach(seat => {
            const elId = this.getElIdFromDbSeat(seat)
            const seatElement = document.getElementById(elId)
            if (seatElement) {
              seatElement.setAttribute('seat', seat.id)
            }
          })

          this.seatObjects.forEach(el => {
            const id = el.getAttribute('ref')
            const seatElement = document.getElementById(id)
            if (seatElement) {
              const hasAttr = seatElement.getAttribute('seat')
              if (!hasAttr) {
                el.style.display = 'none'
              } else {
                el.style.display = ''
              }
            }
          })

          this.$emit('mapLoaded')
        }).finally(() => {
          this.loadingSeats = false
        })
    },
    getElIdFromDbSeat(seat) {
      return `${seat.sector_slug}xr${seat.row_sector}xm${seat.seat_number}`
    },
    setSeatColor(id, color) {
      const seatElement = document.getElementById(id) || document.querySelector(`[seat="${id}"]`)
      if (seatElement) {
        seatElement.setAttribute('fill', color)
        seatElement.setAttribute('stroke', color)
        seatElement.setAttribute('color', color)
        seatElement.style.fill = color
        seatElement.style.stroke = color
        if (this.defaultDisabled) {
          seatElement.classList.remove('disabled')
        }
      }
    },
    setSeatsColorsBatch(seatsData, chunkSize = 100) {
      // Батчинг DOM операций для массовой установки цветов
      // seatsData - массив объектов {id: string, color: string}
      if (!seatsData || seatsData.length === 0) return

      const mapElement = document.getElementById('map')
      if (!mapElement) return

      let index = 0
      const processChunk = () => {
        const end = Math.min(index + chunkSize, seatsData.length)

        for (let i = index; i < end; i++) {
          const { id, color } = seatsData[i]
          const seatElement = document.getElementById(id) || mapElement.querySelector(`[seat="${id}"]`)
          if (seatElement) {
            seatElement.setAttribute('fill', color)
            seatElement.setAttribute('stroke', color)
            seatElement.setAttribute('color', color)
            seatElement.style.fill = color
            seatElement.style.stroke = color
            if (this.defaultDisabled) {
              seatElement.classList.remove('disabled')
            }
          }
        }

        index = end

        if (index < seatsData.length) {
          requestAnimationFrame(processChunk)
        }
      }

      requestAnimationFrame(processChunk)
    },
    setSeatOutlineColor(id, color) {
      const mapElement = document.getElementById('map')
      const seat = document.getElementById(id) || (mapElement ? mapElement.querySelector(`[seat="${id}"]`) : null)
      if (seat) {
        const fill = seat.style.fill || seat.getAttribute('fill')
        seat.dataset.fill = fill || ''
        seat.style.fill = ''
        seat.style.stroke = color
        seat.style.strokeWidth = '2px'
      }
    },
    setSeatOnlyOutline(id, color) {
      const mapElement = document.getElementById('map')
      const seat = document.getElementById(id) || (mapElement ? mapElement.querySelector(`[seat="${id}"]`) : null)
      if (seat) {
        seat.style.stroke = color
        seat.style.strokeWidth = '1px'
      }
    },
    removeSeatOnlyOutline(id) {
      const mapElement = document.getElementById('map')
      const seat = document.getElementById(id) || (mapElement ? mapElement.querySelector(`[seat="${id}"]`) : null)
      if (seat) {
        seat.style.stroke = ''
        seat.style.strokeWidth = ''
      }
    },
    removeSeatOutline(id) {
      const mapElement = document.getElementById('map')
      const seat = document.getElementById(id) || (mapElement ? mapElement.querySelector(`[seat="${id}"]`) : null)
      if (seat) {
        const fill = seat.dataset.fill || ''
        seat.style.fill = fill
        seat.style.stroke = ''
        seat.style.strokeWidth = ''
      }
    },
    setDisabledSeatColor(id) {
      const mapElement = document.getElementById('map')
      const seat = document.getElementById(id) || (mapElement ? mapElement.querySelector(`[seat="${id}"]`) : null)
      if (seat) {
        seat.style.stroke = '#000000'
      }
    },
    setDefaultSeatColor(id) {
      const seat = document.getElementById(id)
      if (seat) {
        seat.style.fill = ''
        seat.style.stroke = ''
      }
    },
    refetchHallSeats() {
      this.getHallRealSeats()
    },
    setSelected(id) {
      const mapElement = document.getElementById('map')
      const el = document.getElementById(id) || (mapElement ? mapElement.querySelector(`[seat="${id}"]`) : null)
      if (el) {
        el.classList.add('selected')
      }
    },
    unsetSelected(id) {
      const mapElement = document.getElementById('map')
      const el = document.getElementById(id) || (mapElement ? mapElement.querySelector(`[seat="${id}"]`) : null)
      if (el) {
        el.classList.remove('selected')
      }
    },
    setPlaceText(el) {
      const parent = el.parentNode
      const svgNS = 'http://www.w3.org/2000/svg'
      const text = document.createElementNS(svgNS, 'text')
      text.setAttributeNS(null, 'x', '0')
      text.setAttributeNS(null, 'y', '1.5')
      text.setAttributeNS(null, 'font-size', '.3em')
      text.setAttributeNS(null, 'text-anchor', 'middle')
      text.setAttributeNS(null, 'stroke', '#000')
      text.setAttributeNS(null, 'stroke-width', '0')
      text.style.pointerEvents = 'none'
      text.style.display = 'none'
      text.classList.add('textNS')
      const xmPlace = el.getAttribute('xm')
      const textNode = document.createTextNode(xmPlace)
      text.appendChild(textNode)
      parent.appendChild(text)
    },
  },
  mounted() {
    if(!this.isWidget) {
      this.eventBC.onmessage = (e) => {
        const data = e.data

        if (data.activeSeatId) {
          const mapElement = document.getElementById('map')
          const target = document.getElementById(data.activeSeatId) || mapElement?.querySelector(`[seat="${data.activeSeatId}"]`)
          if (target) this.seatMouseOver({ target })
        }

        if (!data.activeSeatId) this.TShow = false
      }
    }
  },
  beforeDestroy() {
    if (this.eventBC && !this.isWidget) {
      this.eventBC.close()
      this.eventBC = null
    }
  },
}
</script>

<style scoped lang="scss">

.load-map {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.map-tooltip {
  max-width: 195px;
  background: rgb(82, 82, 82);
  color: #ffffff;
  text-align: center;
  margin: -8px 0 0;
  padding: 7px 13px 7px 13px;
  border-radius: 8px;
  position: absolute;
  transform: translate(-50%, -100%);
  font-size: 11px;

  .triangle {
    border-width: 0 6px 6px;
    border-color: transparent;
    border-bottom-color: rgb(82, 82, 82);
    position: absolute;
    bottom: -5px;
    transform: rotate(180deg) translateX(-50%);
    left: calc(50% - 12px);
    border-style: solid;
  }
}

.map-wrapper {
  position: relative;
  height: 100%;
  // display: flex; // Ломает позиционирование карты
  align-items: center;
  justify-content: center;
}

.map-svg {
  margin: auto;
  display: block;
  // width: 100%;  // Так делать нельзя! В этом случае будут отображаться области, которые отображаться в svg не должны!
  // height: 100%; //
  position: absolute;
  opacity: 0;
}

.zoom-buttons {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  z-index: 10;

  button {
    display: block;
    border: none;
    width: 32px;
    height: 32px;
    background-color: rgba(108, 117, 125, 0.12);
    overflow: hidden;
    border-radius: 50%;
    padding: 0;
    margin: 10px 0;
  }
}

.context-menu {
  position: absolute;
  z-index: 10;
  transform: translateX(-50%) translateY(0);
  max-width: 200px;
  width: 100%;

  &:before {
    content: '';
    border-width: 0 6px 6px;
    border-color: transparent;
    border-bottom-color: rgba(34, 41, 47, 0.125);
    position: absolute;
    top: -5px;
    left: 50%;
    transform: rotate(0) translateX(-50%);
    border-style: solid;
  }
}

</style>
<style>
:root {
  --clip-path: inset(0 0);
}

.polygon{
  clip-path: var(--clip-path);
  opacity: 1;
}

.map-seat {
  fill: #EFEFEF;
  stroke-width: 0;
}

.map-seat:hover {
  filter: brightness(80%);
}

.map-seat.filter-hide {
  display: none !important;
}

.map-seat.disabled {
  pointer-events: none;
  r: 4;
}

.map-seat.selected {
  stroke-width: 2px !important;
  fill: white !important;
}

.map-tooltip.tooltip-variant-1 {
  background: #7367F0;
  padding: 10px 15px 10px 15px;
  font-size: 13px;
  line-height: 24px;
}

.map-tooltip.tooltip-variant-1 .triangle {
  border-bottom-color: #7367F0;
}

.map-tooltip .seat-marks-tooltip {
  border-top: 1px solid rgba(255, 255, 255, 0.35);
  margin-top: 8px;
  padding-top: 7px;
  text-align: left;
  white-space: normal;
}

.map-tooltip .seat-marks-tooltip__group + .seat-marks-tooltip__group {
  margin-top: 7px;
}

.map-tooltip .seat-marks-tooltip__label {
  display: block;
  font-weight: 600;
  line-height: 18px;
  padding-left: 19px;
  position: relative;
}

.map-tooltip .seat-marks-tooltip__icon {
  align-items: center;
  border: 1px solid currentColor;
  border-radius: 50%;
  color: currentColor;
  display: inline-flex;
  flex: 0 0 14px;
  font-size: 10px;
  font-weight: 700;
  height: 14px;
  justify-content: center;
  left: 0;
  line-height: 1;
  position: absolute;
  top: 2px;
  width: 14px;
}

.map-tooltip .seat-marks-tooltip__entry {
  margin-top: 3px;
}

.map-tooltip .seat-marks-tooltip__comment {
  line-height: 18px;
  overflow-wrap: anywhere;
}

.map-tooltip .seat-marks-tooltip__metadata {
  font-size: 11px;
  line-height: 16px;
  opacity: 0.75;
}

.circle-outline {
  outline: 1px solid #666666;
  stroke-width: 0;
  border-radius: 50%;
}
.circle-outline.disabled{
  stroke-width: 1;
  outline-width: 0;
}

.circle-opacity {
  opacity: 0;
}
</style>
